import React from "react";
import { Link } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

const linkButtonStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  background: "#ffffff",
  color: "#111827",
  padding: "0.8rem 1rem",
  fontWeight: 700,
};

const services = [
  {
    id: "svc-1",
    name: "Haircut and beard trim",
    price: "£35.00",
    duration: "45 min",
  },
  {
    id: "svc-2",
    name: "Bridal makeup trial",
    price: "£70.00",
    duration: "75 min",
  },
];

export default function ProviderServicesPage() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
          <div>
            <h2 style={{ margin: 0, color: "#0f172a" }}>Services</h2>
            <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
              Manage provider services, pricing, durations, and booking eligibility.
            </p>
          </div>

          <Link to="/provider/dashboard/services/new" style={linkButtonStyle}>
            Add service
          </Link>
        </div>
      </section>

      {services.map((service) => (
        <section key={service.id} style={cardStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
            <div>
              <h3 style={{ margin: 0, color: "#0f172a" }}>{service.name}</h3>
              <p style={{ margin: "0.45rem 0 0", color: "#475569" }}>
                {service.price} · {service.duration}
              </p>
            </div>

            <Link
              to={`/provider/dashboard/services/${service.id}`}
              style={linkButtonStyle}
            >
              View service
            </Link>
          </div>
        </section>
      ))}
    </div>
  );
}